import { render, staticRenderFns } from "./UnnoSearchPop.vue?vue&type=template&id=a9bef7de&scoped=true"
import script from "./UnnoSearchPop.vue?vue&type=script&lang=js"
export * from "./UnnoSearchPop.vue?vue&type=script&lang=js"
import style0 from "./UnnoSearchPop.vue?vue&type=style&index=0&id=a9bef7de&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9bef7de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9bef7de')) {
      api.createRecord('a9bef7de', component.options)
    } else {
      api.reload('a9bef7de', component.options)
    }
    module.hot.accept("./UnnoSearchPop.vue?vue&type=template&id=a9bef7de&scoped=true", function () {
      api.rerender('a9bef7de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/UnnoSearchPop.vue"
export default component.exports